import { useRouterState } from '@tanstack/react-router'
import { useEffect, useRef, useState } from 'react'

import type { CookieConsent } from '../../utils/cookieConsent'
import { readCookieConsent, subscribeCookieConsent } from '../../utils/cookieConsent'
import {
    initMetaPixel,
    isMetaPixelEnabled,
    META_PIXEL_ID,
    trackMetaPageView,
} from '../../utils/metaPixel'

export const MetaPixel = () => {
    const pathname = useRouterState({ select: (state) => state.location.pathname })
    const [consent, setConsent] = useState<CookieConsent | null>(null)
    const isFirstPageView = useRef(true)

    useEffect(() => {
        setConsent(readCookieConsent())
        return subscribeCookieConsent(setConsent)
    }, [])

    useEffect(() => {
        if (consent === 'accepted') initMetaPixel()
    }, [consent])

    useEffect(() => {
        if (consent !== 'accepted') return
        if (isFirstPageView.current) {
            isFirstPageView.current = false
            return
        }
        trackMetaPageView()
    }, [pathname, consent])

    if (!isMetaPixelEnabled() || consent !== 'accepted') return null

    return (
        <noscript>
            <img
                height="1"
                width="1"
                style={{ display: 'none' }}
                alt=""
                src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
            />
        </noscript>
    )
}
